import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import NavbarModulo from '../../components/NavbarModulo';

class PersonalExternoList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar, getModulo, getPais } = this.props;
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        listar();
        getModulo(modulo[5],modulo[4]);
        getPais(modulo[7]);
    }
    render(){
        const { data, loader, modulo, eliminar, paisN } = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        let titulo = '';
        return(
            <React.Fragment>
                <NavbarModulo
                    pais={paisN}
                    modulo={modulo}
                    titulo={titulo}
                />
                <br />
                <h3 className="p-2 bg-secondary title">Personal externo</h3>
                <br />
                <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                        href={`/#/visitador_medico/${id_emp[5]}/personal_externo/crear/${id_emp[7]}`}
                        className='btn btn-primary'
                    >
                        Crear personal externo
                    </a>
                </div>
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data} 
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        //onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="nombre"
                            headerAlign="center"
                            width="200"
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Nombre
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="puesto"
                            headerAlign="center"
                            width="200"
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Puesto
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            thStyle={
                            {color: 'white'}}
                            dataField="id"
                            width="180"
                            dataAlign="center"
                            dataSort
                            dataFormat={standardActions({ 
                                editar: "personal_externo", 
                                ver: "personal_externo",
                                eliminar: eliminar
                            })} 
                            
                        >
                            Acciones
                        </TableHeaderColumn>
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default PersonalExternoList;
